export default __webpack_public_path__ + "static/media/payments.a6d0bcd6.svg";